import React from 'react';
import PropTypes from 'prop-types';
import WantToLeave from '../ModalThemeWantToLeave';
import * as Translations from '../../providers/i18n';
import './style.scss';

const LeaveWithoutInvite = ({ onStayClick, onLeaveClick, i18n }) => (
    <WantToLeave name="leave-without-invite-modal attachments_preview-package order_page_perseus"
        autoOpen={true}
        buttonTextLeave={i18n.t('attachments_preview.leave-without-invite.leave')}
        buttonTextStay={i18n.t('attachments_preview.leave-without-invite.stay')}
        onClickCloseButton={onLeaveClick}
        onClickStayButton={onStayClick}
        onClickLeaveButton={onLeaveClick}
        header={i18n.t('attachments_preview.leave-without-invite.header')}
        className="leave-without-invite">
        {() => (
            <p className="font-accent modal-text">{i18n.t('attachments_preview.leave-without-invite.text')}</p>
        )}
    </WantToLeave>
);

LeaveWithoutInvite.propTypes = {
    onStayClick: PropTypes.func,
    onLeaveClick: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    })
};

export default Translations.connect(LeaveWithoutInvite);
